import React, { useState, useRef, useEffect } from 'react';
import './PromptSample.css'
export default function MonitorPromptSample({ prompt, lm_log }) {
  const [displayFullJson, setDisplayFullJson] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current && !displayFullJson) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
    if (textareaRef.current && displayFullJson) {
      textareaRef.current.scrollTop = 0;
    }
  }, [displayFullJson]);


  return (
    <div className="container" key={prompt.fileName}>
      <button onClick={() => setDisplayFullJson(!displayFullJson)}>
        {displayFullJson ? <p>lm log</p> : <p>prompt</p>}
      </button>
      {displayFullJson ?
        <textarea className="promptTextArea"
          ref={textareaRef}
          name="prompts"
          placeholder="Prompts"
          onChange={(x) => { }}
          value={lm_log}
          key="prompt"
          style={{
            height: '900px'
          }}
        /> :
        <textarea className="promptTextArea"
          ref={textareaRef}
          onChange={(x) => { }}
          value={prompt}
          key="prompt"
          style={{
            height: '900px'
          }}
        />}
    </div>
  )
};